import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec cloud_computing_tabs p-100">
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} className="m-auto text-center">
            <h3 className="h3_head">
              Tech Stack for <span>eCommerce Website Development</span> Services
            </h3>
            <p>
              As a leading eCommerce website development company, we specialize
              in building novel, scalable, and high-performance online stores.
              Our tech stack leverages the latest, most reliable technologies to
              ensure seamless and responsive user experiences.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend Development">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/frontend/NextJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>NextJs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/frontend/NueJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>VueJs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/frontend/Reactnative.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>ReactJS</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Backend Development">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/backend/Django.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Django</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/backend/ExpressJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>ExpressJs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/backend/Node.js.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Node js</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Database">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/my_sql.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MySQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/MongoDB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/PostgreSQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>PostgreSQL</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="APIs Integrations">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/api/Firebase_Cloud_Messaging.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase Cloud Messaging</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/api/GraphQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>GraphQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/api/RESTful_APIs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Restful APIs</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="DevOps">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/devops/docker.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Docker</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/devops/GitHub_Actions.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>GitHub Actions</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/devops/Jenkins.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Jenkins</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="6" title="Payment Gateways">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/payment/PayPal.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>PayPal</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/payment/Square.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Square</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/api/Stripe.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Stripe</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="7" title="Performance Optimization">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/performance/Lighthouse.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Lighthouse</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/performance/Webpack.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Webpack</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="8" title="Security">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/security/JWT.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>JWT</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/security/OAuth.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>OAuth</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/security/TLS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>TLS</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
